import img3achs from '@/assets/gallery/gehaeuse-01.png';
import img5achs from '@/assets/gallery/5achs-bauteil-01.png';
import imgCam from '@/assets/machines/onecnc-cadcam.jpg';
import imgProto from '@/assets/gallery/praezisionsbauteil-01.png';

export interface ServiceDetail {
  slug: string;
  name: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  intro: string;
  image: string;
  imageAlt: string;
  highlights: { label: string; value: string }[];
  sections: { heading: string; body: string; bullets?: string[] }[];
  faqs: { question: string; answer: string }[];
}

export const serviceDetails: ServiceDetail[] = [
  {
    slug: '3-achs-fraesen',
    name: '3-Achs Fräsen',
    title: '3-Achs CNC-Fräsen für Einzelteile und Kleinserien',
    metaTitle: '3-Achs CNC-Fräsen bis 610 x 420 mm | SR-Zerspanung',
    metaDescription:
      '3-Achs CNC-Fräsen von Gehäusen, Platten und Vorrichtungsteilen bis 610 x 420 mm. Einzelteile und Kleinserien in Aluminium, Stahl, Edelstahl und Kunststoff aus Stamsried.',
    intro:
      'Die 3-Achs-Bearbeitung ist unser wirtschaftlichstes Verfahren für prismatische Bauteile: Gehäuse, Platten, Adapter und Vorrichtungsteile fertigen wir in einer Aufspannung präzise, reproduzierbar und mit kurzen Durchlaufzeiten.',
    image: img3achs,
    imageAlt: 'CNC-gefrästes Aluminiumgehäuse aus der 3-Achs-Bearbeitung von SR-Zerspanung',
    highlights: [
      { label: 'Max. Bauteilgröße', value: '610 x 420 mm' },
      { label: 'Ideale Losgröße', value: '1 – 200 Stück' },
      { label: 'Passungen', value: 'bis H7' },
      { label: 'Maschinen', value: 'Hurco VM10i / VMX24i' },
    ],
    sections: [
      {
        heading: 'Typische Bauteile',
        body: 'Wir fräsen überwiegend Komponenten für Sondermaschinenbau und Automatisierungstechnik.',
        bullets: [
          'Gehäuse und Gehäusedeckel',
          'Grund- und Adapterplatten',
          'Vorrichtungs- und Spannteile',
          'Halterungen, Winkel und Konsolen',
          'Ersatzteile nach Muster oder Zeichnung',
        ],
      },
      {
        heading: 'Werkstoffe',
        body: 'Aluminium (u. a. AlMg4,5Mn, AlCuMgPb), Baustahl, Edelstahl, Messing sowie technische Kunststoffe wie POM, PA und PEEK. Sonderwerkstoffe nach Absprache.',
      },
      {
        heading: 'Ablauf',
        body: 'Nach Eingang Ihrer 3D-Daten oder Zeichnung prüfen wir die Fertigbarkeit, kalkulieren und programmieren in OneCNC. Sie erhalten Ihre Teile inklusive Endkontrolle und Messprotokoll auf Wunsch.',
      },
    ],
    faqs: [
      {
        question: 'Wie groß dürfen Bauteile beim 3-Achs-Fräsen sein?',
        answer: 'Wir bearbeiten Teile bis 610 x 420 mm. Bei Grenzfällen prüfen wir die Machbarkeit direkt anhand Ihrer Zeichnung.',
      },
      {
        question: 'Fertigen Sie auch Einzelteile?',
        answer: 'Ja. Einzelteile, Prototypen und Ersatzteile sind ausdrücklich willkommen – wirtschaftlich sind Losgrößen von 1 bis 200 Stück.',
      },
    ],
  },
  {
    slug: '5-achs-fraesen',
    name: '5-Achs Fräsen',
    title: '5-Achs CNC-Fräsen – Komplettbearbeitung in einer Aufspannung',
    metaTitle: '5-Achs CNC-Fräsen bis 350 x 180 mm | SR-Zerspanung',
    metaDescription:
      '5-Achs CNC-Fräsen für komplexe Geometrien bis 350 x 180 mm: Mehrseitenbearbeitung in einer Aufspannung, schräge Bohrungen und Freiformflächen. Einzelteile und Kleinserien.',
    intro:
      'Mit der 5-Achs-Simultanbearbeitung reduzieren wir Spannvorgänge auf ein Minimum. Das erhöht die Lage- und Formgenauigkeit, spart Rüstzeit und macht komplexe Geometrien wirtschaftlich fertigbar.',
    image: img5achs,
    imageAlt: '5-Achs gefrästes Präzisionsbauteil mit komplexer Kontur von SR-Zerspanung',
    highlights: [
      { label: 'Max. Bauteilgröße', value: '350 x 180 mm' },
      { label: 'Bearbeitung', value: 'Simultan 5-Achs' },
      { label: 'Passungen', value: 'bis H7' },
      { label: 'Maschine', value: 'Hurco VMX42Ui' },
    ],
    sections: [
      {
        heading: 'Wann sich 5-Achs lohnt',
        body: 'Immer dann, wenn mehrere Seiten, schräge Flächen oder Bohrungen zueinander exakt in Bezug stehen müssen.',
        bullets: [
          'Mehrseitenbearbeitung in einer Aufspannung',
          'Schräge Bohrungen und Anschraubflächen',
          'Freiform- und Konturflächen',
          'Bauteile mit engen Lagetoleranzen',
          'Reduzierte Rüst- und Durchlaufzeiten',
        ],
      },
      {
        heading: 'Genauigkeit',
        body: 'Weniger Umspannen bedeutet weniger Fehlerquellen. Passungen bis H7 fertigen wir standardmäßig, engere Vorgaben stimmen wir vorab ab, damit Aufwand und Kosten kalkulierbar bleiben.',
      },
      {
        heading: 'Datenübergabe',
        body: 'Optimal sind 3D-Modelle als STEP oder IGES mit bemaßter Zeichnung für Toleranzen, Oberflächen und Gewinde.',
      },
    ],
    faqs: [
      {
        question: 'Welche Bauteilgröße ist in der 5-Achs-Bearbeitung möglich?',
        answer: 'Bis 350 x 180 mm. Größere Bauteile fertigen wir in der 3-Achs-Bearbeitung bis 610 x 420 mm.',
      },
      {
        question: 'Brauche ich für 5-Achs-Teile ein 3D-Modell?',
        answer: 'Ein 3D-Modell (STEP oder IGES) beschleunigt Kalkulation und Programmierung deutlich. Eine bemaßte Zeichnung für Toleranzen sollte beiliegen.',
      },
    ],
  },
  {
    slug: 'cam-programmierung',
    name: 'CAM Programmierung',
    title: 'CAM-Programmierung mit OneCNC',
    metaTitle: 'CAM-Programmierung mit OneCNC | SR-Zerspanung',
    metaDescription:
      'CAM-Programmierung mit OneCNC: intelligente Werkzeugwege, Simulation und Kollisionsprüfung. Wir verarbeiten STEP, IGES, SolidWorks, DXF und DWG.',
    intro:
      'Jede Bearbeitung entsteht zuerst digital. Mit OneCNC erstellen wir Werkzeugwege, simulieren den kompletten Ablauf und prüfen auf Kollisionen – bevor der erste Span fällt.',
    image: imgCam,
    imageAlt: 'CAM-Programmierung mit OneCNC am Arbeitsplatz von SR-Zerspanung',
    highlights: [
      { label: 'CAM-System', value: 'OneCNC' },
      { label: 'Formate', value: 'STEP, IGES, SLDPRT, DXF, DWG' },
      { label: 'Simulation', value: 'inkl. Kollisionsprüfung' },
      { label: 'Machbarkeit', value: 'meist am selben Tag' },
    ],
    sections: [
      {
        heading: 'Unterstützte Dateiformate',
        body: 'Wir verarbeiten die gängigen CAD-Formate. Auch bemaßte PDF-Zeichnungen reichen für eine erste Einschätzung.',
        bullets: [
          'STEP (.step, .stp)',
          'IGES (.iges, .igs)',
          'SolidWorks (.sldprt)',
          'DXF (.dxf)',
          'DWG (.dwg)',
          'PDF-Zeichnung (bemaßt)',
        ],
      },
      {
        heading: 'Was die Programmierung bringt',
        body: 'Durchdachte Werkzeugwege verkürzen Hauptzeiten, schonen Werkzeuge und sorgen für konstante Oberflächen – besonders bei wiederkehrenden Kleinserien, deren Programme wir archivieren.',
      },
      {
        heading: 'Fertigungsgerechte Beratung',
        body: 'Bei der Machbarkeitsprüfung geben wir Hinweise zu Radien, Werkzeugzugänglichkeit und Toleranzen, mit denen sich Ihr Bauteil deutlich kostenoptimierter fertigen lässt.',
      },
    ],
    faqs: [
      {
        question: 'Welche CAD-Daten benötigen Sie?',
        answer: 'Am besten STEP oder IGES plus bemaßte Zeichnung. SolidWorks-Teile, DXF und DWG verarbeiten wir ebenfalls.',
      },
      {
        question: 'Übernehmen Sie auch reine Programmierleistungen?',
        answer: 'Sprechen Sie uns an – in der Regel programmieren wir für die eigene Fertigung, in Einzelfällen ist eine separate Beauftragung möglich.',
      },
    ],
  },
  {
    slug: 'prototypen-kleinserien',
    name: 'Prototypen & Kleinserien',
    title: 'Prototypen und Kleinserien aus der CNC-Fertigung',
    metaTitle: 'Prototypen & Kleinserien CNC gefräst | SR-Zerspanung',
    metaDescription:
      'Prototypen, Ersatzteile und Kleinserien von 1 bis 200 Stück – CNC gefräst, kurzfristig über FastLane oder kostenoptimiert über Smart Production.',
    intro:
      'Ob erster Funktionsmuster-Prototyp, dringendes Ersatzteil oder wiederkehrende Kleinserie: Wir sind auf Losgrößen von 1 bis 200 Stück spezialisiert und liefern planbar.',
    image: imgProto,
    imageAlt: 'CNC-gefräste Präzisionsbauteile einer Kleinserie von SR-Zerspanung',
    highlights: [
      { label: 'Losgröße', value: '1 – 200 Stück' },
      { label: 'FastLane', value: 'Rückmeldung in Minuten' },
      { label: 'Smart Production', value: 'kostenoptimiert' },
      { label: 'Wiederholteile', value: 'Programme archiviert' },
    ],
    sections: [
      {
        heading: 'FastLane – wenn es schnell gehen muss',
        body: 'Für Stillstände und dringende Ersatzteile: Anfrage stellen, Rückmeldung innerhalb von Minuten, Fertigung mit Vorrang eingeplant.',
      },
      {
        heading: 'Smart Production – kostenoptimiert planen',
        body: 'Wenn der Termin Spielraum lässt, fertigen wir Ihre Teile in freien Kapazitäten. Das senkt den Preis spürbar, ohne bei Qualität oder Kontrolle Abstriche zu machen.',
      },
      {
        heading: 'Von der Idee zum Serienteil',
        body: 'Prototyp, Nullserie und Wiederholteil aus einer Hand. Bewährte Programme und Vorrichtungen bleiben erhalten, sodass Nachbestellungen schnell und zum kalkulierbaren Preis laufen.',
        bullets: [
          'Funktionsmuster und Prototypen',
          'Ersatz- und Verschleißteile',
          'Wiederkehrende Kleinserien',
          'Vorrichtungs- und Betriebsmittelbau',
        ],
      },
    ],
    faqs: [
      {
        question: 'Ab welcher Stückzahl fertigen Sie?',
        answer: 'Ab Stückzahl 1. Wirtschaftlich optimal sind Losgrößen von 1 bis 200 Teilen.',
      },
      {
        question: 'Wie schnell erhalte ich eine Rückmeldung?',
        answer: 'Über die FastLane-Anfrage innerhalb von Minuten, bei Standardanfragen innerhalb weniger Stunden.',
      },
    ],
  },
];

export const getServiceBySlug = (slug?: string) => serviceDetails.find((s) => s.slug === slug);
